import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import DashboardLayout from '../../../layouts/DashboardLayout';
import BulkSubTabs from './BulkSubTabs';
import BulkScheduleTable from './BulkScheduleTable';
import { useGetAllInspectorsQuery, useGetBulkPermitsQuery } from '../../../redux/rtkQuery/apiSlice';
import { RootState } from '../../../redux/root';
import { dispatch } from '../../../redux/store';
import { setBulkDate, setBulkInspections } from '../../../redux/slices/bulkSlice';
import BulkScheduleBreadcrumbs from './BulkScheduleBreadcrumbs';

const BulkMain = () => {
  const ref = useRef<HTMLDivElement>();
  const [params, setParams] = useState<any>();
  const { data, isFetching } = useGetBulkPermitsQuery(params, { skip: params === undefined });
  const { data: inspectors } = useGetAllInspectorsQuery(null);
  const { bulkDate } = useSelector((s: RootState) => s.bulkSlice);
  const { tableSelectedRows } = useSelector((s: RootState) => s.general);

  useEffect(() => {
    return () => {
      dispatch(setBulkDate(''));
      dispatch(setBulkInspections([]));
    };
  }, []);
  useEffect(() => {
    if (data) {
      const inspections = data.results.map(i => {
        const inspector = inspectors.find(ins => Number(ins.value) === i.inspector) || { label: '' };
        return {
          ...i,
          inspector: inspector.label,
        };
      });
      dispatch(setBulkInspections(inspections));
    }
  }, [data]);
  useEffect(() => {
    if (bulkDate) {
      const _params = {
        event_type: 'Inspection_scheduling',
        limit: 100000000,
        inspection_date: bulkDate,
      };
      setParams(_params);
    }
  }, [bulkDate]);
  useEffect(() => {
    if (ref.current) {
      ref.current.parentElement.style.padding = '0 0 0 0';
    }
  }, [ref.current]);

  const getCount = () => {
    if (tableSelectedRows && tableSelectedRows.length > 0) {
      const selectedAny = tableSelectedRows.filter(r => r.selected);
      return selectedAny.length;
    }
    return 0;
  };
  return (
    <DashboardLayout>
      <TopWrapper ref={ref}>
        <Wrapper>
          <BulkScheduleBreadcrumbs getCount={getCount} />
          <BulkSubTabs getCount={getCount} />
          <BulkScheduleTable isLoading={isFetching} />
        </Wrapper>
      </TopWrapper>
    </DashboardLayout>
  );
};

export default BulkMain;

const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
`;
